import React from "react"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"

export interface ProjectCardHeaderProps extends WithClassName {
  children?: React.ReactNode
}

export const ProjectCardHeader = React.memo(
  ({ children, className }: ProjectCardHeaderProps) => (
    <div className={classNames("project-card__header", className)}>
      {children}
    </div>
  )
)
